var _require = require('../errors'),
    JWTClaimInvalid = _require.JWTClaimInvalid;

var isNotString = function isNotString(val) {
  return typeof val !== 'string' || val.length === 0;
};

var isNotArrayOfStrings = function isNotArrayOfStrings(val) {
  return !Array.isArray(val) || val.length === 0 || val.some(isNotString);
};

var isRequired = function isRequired(Err, value, label, claim) {
  if (value === undefined) {
    throw new Err("".concat(label, " is missing"), claim, 'missing');
  }
};

var isString = function isString(Err, value, label, claim) {
  var required = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  if (required) {
    isRequired(Err, value, label, claim);
  }

  if (value !== undefined && isNotString(value)) {
    throw new Err("".concat(label, " must be a string"), claim, 'invalid');
  }
};

var isTimestamp = function isTimestamp(value, label) {
  var required = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (required && value === undefined) {
    throw new JWTClaimInvalid("\"".concat(label, "\" claim is missing"), label, 'missing');
  }

  if (value !== undefined && typeof value !== 'number') {
    throw new JWTClaimInvalid("\"".concat(label, "\" claim must be a JSON numeric value"), label, 'invalid');
  }
};

var isStringOrArrayOfStrings = function isStringOrArrayOfStrings(value, label) {
  var required = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (required && value === undefined) {
    throw new JWTClaimInvalid("\"".concat(label, "\" claim is missing"), label, 'missing');
  }

  if (value !== undefined && isNotString(value) && isNotArrayOfStrings(value)) {
    throw new JWTClaimInvalid("\"".concat(label, "\" claim must be a string or array of strings"), label, 'invalid');
  }
};

module.exports = {
  isNotArrayOfStrings: isNotArrayOfStrings,
  isRequired: isRequired,
  isNotString: isNotString,
  isString: isString,
  isTimestamp: isTimestamp,
  isStringOrArrayOfStrings: isStringOrArrayOfStrings
};